import actionTypes from './actionTypes';

const INIT_STATE = {
  createCafeDiscountRequestLoading: false,
  createCafeDiscountRequestFailed: false,
  createCafeDiscountRequestError: false,
  createCafeDiscountRequestMessage: '',

  getMyCafeDiscountsListLoading: false,
  getMyCafeDiscountsListFailed: false,
  getMyCafeDiscountsListError: false,
  getMyCafeDiscountsListMessage: null,

  cafeDiscountRequestsLoading: false,
  cafeDiscountRequestsFailed: false,
  cafeDiscountRequestsError: false,
  cafeDiscountRequestsMessage: null,
  cafeDiscountRequestsList: [],
  cafeDiscountRequests: {},


  cafeDiscountRequestArchivesLoading: false,
  cafeDiscountRequestArchivesFailed: false,
  cafeDiscountRequestArchivesError: false,
  cafeDiscountRequestArchivesMessage: null,
  cafeDiscountRequestArchivesList: [],
  cafeDiscountRequestArchives: {},


  cafeDiscountRequestDetailsByIdLoading: false,
  cafeDiscountRequestDetailsByIdFailed: false,
  cafeDiscountRequestDetailsByIdError: false,
  cafeDiscountRequestDetailsByIdMessage: null,
  cafeDiscountRequestDetailsById: {},


  updateCafeDiscountRequestStatusLoading: false,
  updateCafeDiscountRequestStatusFailed: false,
  updateCafeDiscountRequestStatusError: false,
  updateCafeDiscountRequestStatusMessage: null,


  myCafeDiscountsList: [],
  myCafeDiscountsListTotalRecords: 0
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case actionTypes.CREATE_CAFE_DISCOUNT_REQUEST_LOADING: {
      return {
        ...state,
        createCafeDiscountRequestLoading: true,
        createCafeDiscountRequestFailed: false,
        createCafeDiscountRequestError: false,
        createCafeDiscountRequestMessage: ''
      };
    }
    case actionTypes.CREATE_CAFE_DISCOUNT_REQUEST_SUCCESS: {
      return {
        ...state,
        createCafeDiscountRequestLoading: false,
        createCafeDiscountRequestFailed: false,
        createCafeDiscountRequestError: false,
        createCafeDiscountRequestMessage: ''
      };
    }
    case actionTypes.CREATE_CAFE_DISCOUNT_REQUEST_REJECT: {
      return {
        ...state,
        createCafeDiscountRequestLoading: false,
        createCafeDiscountRequestFailed: false,
        createCafeDiscountRequestError: true,
        createCafeDiscountRequestMessage: ''
      };
    }
    case actionTypes.CREATE_CAFE_DISCOUNT_REQUEST_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        createCafeDiscountRequestLoading: false,
        createCafeDiscountRequestFailed: true,
        createCafeDiscountRequestError: false,
        createCafeDiscountRequestMessage: message
      };
    }

    case actionTypes.GET_MY_CAFE_DISCOUNTS_LIST_LOADING:
      return {
        ...state,
        myCafeDiscountsList: [],
        myCafeDiscountsListTotalRecords: 0,
        getMyCafeDiscountsListLoading: true,
        getMyCafeDiscountsListFailed: false,
        getMyCafeDiscountsListError: false,
        getMyCafeDiscountsListMessage: null
      };
    case actionTypes.GET_MY_CAFE_DISCOUNTS_LIST_SUCCESS:
      return {
        ...state,
        myCafeDiscountsList: action.payload.cafeDiscounts,
        myCafeDiscountsListTotalRecords: action.payload.totalRecords,
        getMyCafeDiscountsListLoading: false,
        getMyCafeDiscountsListFailed: false,
        getMyCafeDiscountsListError: false,
        getMyCafeDiscountsListMessage: null
      };
    case actionTypes.GET_MY_CAFE_DISCOUNTS_LIST_FAILED:
      return {
        ...state,
        myCafeDiscountsList: [],
        myCafeDiscountsListTotalRecords: 0,
        getMyCafeDiscountsListLoading: false,
        getMyCafeDiscountsListFailed: false,
        getMyCafeDiscountsListError: false,
        getMyCafeDiscountsListMessage: action.payload.message
      };
    case actionTypes.GET_MY_CAFE_DISCOUNTS_LIST_REJECT:
      return {
        ...state,
        myCafeDiscountsList: [],
        myCafeDiscountsListTotalRecords: 0,
        getMyCafeDiscountsListLoading: false,
        getMyCafeDiscountsListFailed: false,
        getMyCafeDiscountsListError: true,
        getMyCafeDiscountsListMessage: null
      };


    case actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUESTS_LOADING:
      return {
        ...state,
        cafeDiscountRequests: {},
        cafeDiscountRequestsList: [],
        cafeDiscountRequestsLoading: true,
        cafeDiscountRequestsFailed: false,
        cafeDiscountRequestsError: false,
        cafeDiscountRequestsMessage: null
      };
    case actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUESTS_SUCCESS:
      return {
        ...state,
        cafeDiscountRequests: { ...action.payload },
        cafeDiscountRequestsList: [...action.payload.cafeDiscounts],
        cafeDiscountRequestsLoading: false,
        cafeDiscountRequestsFailed: false,
        cafeDiscountRequestsError: false,
        cafeDiscountRequestsMessage: null
      };
    case actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUESTS_FAILED:
      return {
        ...state,
        cafeDiscountRequests: {},
        cafeDiscountRequestsList: [],
        cafeDiscountRequestsLoading: false,
        cafeDiscountRequestsFailed: false,
        cafeDiscountRequestsError: false,
        cafeDiscountRequestsMessage: action.payload.message
      };
    case actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUESTS_REJECT:
      return {
        ...state,
        cafeDiscountRequests: {},
        cafeDiscountRequestsList: [],
        cafeDiscountRequestsLoading: false,
        cafeDiscountRequestsFailed: false,
        cafeDiscountRequestsError: true,
        cafeDiscountRequestsMessage: null
      };



    case actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_LOADING:
      return {
        ...state,
        cafeDiscountRequestArchives: {},
        cafeDiscountRequestArchivesList: [],
        cafeDiscountRequestArchivesLoading: true,
        cafeDiscountRequestArchivesFailed: false,
        cafeDiscountRequestArchivesError: false,
        cafeDiscountRequestArchivesMessage: null
      };
    case actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_SUCCESS:
      return {
        ...state,
        cafeDiscountRequestArchives: { ...action.payload },
        cafeDiscountRequestArchivesList: [...action.payload.cafeDiscounts],
        cafeDiscountRequestArchivesLoading: false,
        cafeDiscountRequestArchivesFailed: false,
        cafeDiscountRequestArchivesError: false,
        cafeDiscountRequestArchivesMessage: null
      };
    case actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_FAILED:
      return {
        ...state,
        cafeDiscountRequestArchives: {},
        cafeDiscountRequestArchivesList: [],
        cafeDiscountRequestArchivesLoading: false,
        cafeDiscountRequestArchivesFailed: false,
        cafeDiscountRequestArchivesError: false,
        cafeDiscountRequestArchivesMessage: action.payload.message
      };
    case actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_REJECT:
      return {
        ...state,
        cafeDiscountRequestArchives: {},
        cafeDiscountRequestArchivesList: [],
        cafeDiscountRequestArchivesLoading: false,
        cafeDiscountRequestArchivesFailed: false,
        cafeDiscountRequestArchivesError: true,
        cafeDiscountRequestArchivesMessage: null
      };

    case actionTypes.FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_LOADING:
      return {
        ...state,
        cafeDiscountRequestDetailsById: {},
        cafeDiscountRequestDetailsByIdLoading: true,
        cafeDiscountRequestDetailsByIdFailed: false,
        cafeDiscountRequestDetailsByIdError: false,
        cafeDiscountRequestDetailsByIdMessage: null
      };
    case actionTypes.FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_SUCCESS:
      return {
        ...state,
        cafeDiscountRequestDetailsById: { ...action.payload },
        cafeDiscountRequestDetailsByIdLoading: false,
        cafeDiscountRequestDetailsByIdFailed: false,
        cafeDiscountRequestDetailsByIdError: false,
        cafeDiscountRequestDetailsByIdMessage: null
      };
    case actionTypes.FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_FAILED:
      return {
        ...state,
        cafeDiscountRequestDetailsById: {},
        cafeDiscountRequestDetailsByIdLoading: false,
        cafeDiscountRequestDetailsByIdFailed: false,
        cafeDiscountRequestDetailsByIdError: false,
        cafeDiscountRequestDetailsByIdMessage: action.payload.message
      };
    case actionTypes.FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_REJECT:
      return {
        ...state,
        cafeDiscountRequestDetailsById: {},
        cafeDiscountRequestDetailsByIdLoading: false,
        cafeDiscountRequestDetailsByIdFailed: false,
        cafeDiscountRequestDetailsByIdError: true,
        cafeDiscountRequestDetailsByIdMessage: null
      };


    case actionTypes.UPDATE_CAFE_DISCOUNT_REQUEST_LOADING:
      return {
        ...state,
        updateCafeDiscountRequestStatusLoading: true,
        updateCafeDiscountRequestStatusFailed: false,
        updateCafeDiscountRequestStatusError: false,
        updateCafeDiscountRequestStatusMessage: null
      };
    case actionTypes.UPDATE_CAFE_DISCOUNT_REQUEST_SUCCESS:
      return {
        ...state,
        updateCafeDiscountRequestStatusLoading: false,
        updateCafeDiscountRequestStatusFailed: false,
        updateCafeDiscountRequestStatusError: false,
        updateCafeDiscountRequestStatusMessage: null
      };
    case actionTypes.UPDATE_CAFE_DISCOUNT_REQUEST_FAILED:
      return {
        ...state,
        updateCafeDiscountRequestStatusLoading: false,
        updateCafeDiscountRequestStatusFailed: false,
        updateCafeDiscountRequestStatusError: false,
        updateCafeDiscountRequestStatusMessage: action.payload.message
      };
    case actionTypes.UPDATE_CAFE_DISCOUNT_REQUEST_REJECT:
      return {
        ...state,
        updateCafeDiscountRequestStatusLoading: false,
        updateCafeDiscountRequestStatusFailed: false,
        updateCafeDiscountRequestStatusError: true,
        updateCafeDiscountRequestStatusMessage: null
      };

    case actionTypes.CLEAR_CREATE_CAFE_DISCOUNT_REQUEST_FORM: {
      return {
        ...state,
        createCafeDiscountRequestLoading: false,
        createCafeDiscountRequestFailed: false,
        createCafeDiscountRequestError: false,
        createCafeDiscountRequestMessage: ''
      };
    }

    default: {
      return { ...state };
    }
  }
};
